import Vue from 'vue';
import VueRouter from 'vue-router';
import { routeClearUp } from '@/common/helpers/import-async';
import control from '@/router/control';
function setRoute(routeName, pageName, config) {
    return routeClearUp(routeName, pageName, config);
}
var pageList = process.env.PAGE_LIST;
var routes = [];
var mode = 'history';
if (pageList && pageList.length) {
    pageList.forEach(function (page) {
        var currentPageConfig = require("../views/" + page.relativePath + "/page.config.ts").default;
        var relativePath = page.relativePath.split('/pages/');
        var routeName = relativePath[0];
        var pageName = relativePath[1];
        routes.push(setRoute(routeName, pageName, currentPageConfig));
    });
}
var scrollBehavior = function (to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    }
    else {
        return { x: 0, y: 0 };
    }
};
Vue.use(VueRouter);
var router = new VueRouter({
    routes: routes,
    mode: mode,
    scrollBehavior: scrollBehavior
});
control(router);
export default router;
